import {
  SidePanelTabName,
  useFeatureExtractionContext,
} from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { VerticalTab } from '@trimble/ui-components/solidjs';
import { Accessor, createMemo } from 'solid-js';
import { LayersTab } from './LayersTab';

export function createLayersSidePanelTab(): VerticalTab<SidePanelTabName> {
  return {
    name: SidePanelTabName.Layers,
    tooltip: {
      text: t('mobileMapping.layers.title'),
      position: 'right',
    },
    icon: 'layer',
    iconClass: 'modus-icons',
    content: () => <LayersTab />,
  };
}

export function useLayersSidePanelTab(): Accessor<
  readonly VerticalTab<SidePanelTabName>[]
> {
  const featureExtraction = useFeatureExtractionContext();

  const layersSidePanelTab = createMemo(() =>
    featureExtraction.isFeatureExtractionEnabled()
      ? [createLayersSidePanelTab()]
      : []
  );

  return layersSidePanelTab;
}
